import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { domainUrl } from '../../../constants'
import { checkAuthorization } from '../../../helpers';
import { message } from 'antd'

export const getProjectTrack = createAsyncThunk('getprojecttrackStatistics',
    async (object, { dispatch, getState }) => {

        const {userToken}= checkAuthorization()
        dispatch(gettingProjectTrackDetail())
        var myHeaders = new Headers();
        myHeaders.append("Authorization", userToken)
        myHeaders.append("Content-Type", "application/json")
        myHeaders.append("pageNO", object?.pageNo)
        myHeaders.append("recordsPerPage", object?.pageSize)
        var requestOptions = {
            method: 'Post',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({name: object?.name})
        };
        fetch(domainUrl + `/viewAllProjectsAdmin`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    dispatch(projecttrackDetailResponse(result?.data))
                    dispatch(setPages({pageNo: object?.pageNo, pageSize: object?.pageSize, totalRecords: result?.totalRecords}))
                }
                else 
                    throw result?.message
            })
            .catch(error => { 
                dispatch(projecttrackDetailClear())
                message.error(error) 
            })
    }
)


export const updateProjecttrackStatus = createAsyncThunk('getStatusStatistics',
    async (object, { dispatch, getState }) => {

        const { userToken } = checkAuthorization()
        var myHeaders = new Headers();
        myHeaders.append("Authorization", userToken)
        myHeaders.append("Content-Type", "application/json")
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({ id: object?.id, status: object?.status })
        };
        fetch(domainUrl + `/updateProjectStatus`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    const data = result?.data;
                    dispatch(projecttrackstatusResponse({id: data?.id, status: data?.status}))
                }
                else
                    throw result?.message
            })
            .catch(error => {
                message.error(error)
            })
    }
)


const GetProjectTrackApiSlice = createSlice({
    name: 'ProjectTrackgetapi',
    initialState: {
        projectData: null,
        loadingproject: false,
        pagination:{
            pageNo:1,
            pageSize: 10,
            totalRecords:0,
        },
        filters: {
            name: '',
            id: '',
            status: '',
        },
    },
    reducers: {
        gettingProjectTrackDetail: state => {
            state.loadingproject=true
            state.projectData=null
        },
        projecttrackDetailResponse: (state, action)=>{
            state.projectData= action.payload
            state.loadingproject= false
        },
        projecttrackDetailClear: (state)=>{
            state.projectData= null
            state.loadingproject= false
        },
        changeProjectTrackDetailFilters: (state, action) => {
            state.filters = action.payload
        },
        setPages:(state, action)=>{
            state.pagination= action.payload
        },
        projecttrackstatusResponse: (state, action) => {
            const { id, status } = action.payload
            const trackIndex = state.projectData.findIndex(pro => pro.id === id)
            if (trackIndex !== -1) {
                state.projectData[trackIndex].status = status
            }
            state.loadingproject = false
        }
    },
})
export const { 
    gettingProjectTrackDetail, projecttrackDetailResponse, projecttrackDetailClear,
    changeProjectTrackDetailFilters, setPages, projecttrackstatusResponse
} = GetProjectTrackApiSlice.actions;
export default GetProjectTrackApiSlice.reducer;